import { Button, ExclusiveChoice, ModalPanel, Title } from "dash-styled"
import React, { FC, useCallback, useState } from "react"
import {
    APIOrgMemberRole,
    apiOrgMemberRoleList
} from "../../../../../../Models/API/APIOrgMember"
import { Labeled } from "../../../../../Common/Render/Common/Labeled/Labeled"
import capitalize from "lodash/capitalize"

interface OrgMemberChangeRoleModalProps {
    currentRole: APIOrgMemberRole
    isSaving: boolean
    onClose: () => void
    onSubmit: (role: APIOrgMemberRole) => void
}

export const OrgMemberChangeRoleModal: FC<OrgMemberChangeRoleModalProps> = ({
    currentRole,
    isSaving,
    onClose,
    onSubmit
}) => {
    const [role, setRole] = useState<APIOrgMemberRole>(currentRole)
    const handleSubmit = useCallback(() => onSubmit(role), [onSubmit, role])

    return (
        <ModalPanel onClose={onClose} className="max-w-2xl w-full">
            <Title variant="heading2" weight="semibold" component="h2">
                Change member role
            </Title>
            <Labeled label="Role" errors={[]}>
                <ExclusiveChoice
                    withPanel={false}
                    choices={[...apiOrgMemberRoleList]}
                    selectedIndex={
                        role === undefined
                            ? -1
                            : apiOrgMemberRoleList.indexOf(role)
                    }
                    renderChoice={capitalize}
                    onClick={index => setRole(apiOrgMemberRoleList[index])}
                />
            </Labeled>
            <div className="flex justify-center">
                <Button color="plain" onClick={onClose} className="w-48 mr-4">
                    Cancel
                </Button>
                <Button
                    disabled={isSaving || role === currentRole}
                    className="w-48"
                    onClick={handleSubmit}
                >
                    {isSaving ? "Updating..." : "Update"}
                </Button>
            </div>
        </ModalPanel>
    )
}
